import { 
    FEATURE_COMING_SOON, FEEDBACK_MESSAGE, INVALID_UTILITY_RATE, 
    NO_TENANT_IN_UNIT, REMOVE_MODAL, 
    SHOW_CUSTOM_ERROR, SHOW_ERROR 
} from "./actionTypes";

const removeModal = () => ({
    type: REMOVE_MODAL,
    errors: null
});

const showErrorModal = (error) => ({
    type: SHOW_ERROR,
    errors: error
})

const showCustomError = (error) => ({
    type: SHOW_CUSTOM_ERROR,
    errors: error
})

const showFeatureComingSoon = () => ({
    type: FEATURE_COMING_SOON,
    errors: null
})

const noTenantinUnit = () => ({
    type: NO_TENANT_IN_UNIT,
    errors: "The Unit you are trying to create a utility invoice for is not occupied"
})

const invalidUtilityRate = () => ({
    type: INVALID_UTILITY_RATE,
    errors: "The utility rate for the utility item is invalid"
})

const showCustomMessage = (title="", message="") => ({
    type: FEEDBACK_MESSAGE,
    payload: {
        title, message
    },
    errors: null
})

export {
    removeModal, showErrorModal, showCustomError, showCustomMessage,
    showFeatureComingSoon, noTenantinUnit, invalidUtilityRate
};